/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { ResponsivePie } from '@nivo/pie';
import { useChartTheme } from '@/hooks';

interface Props {
  data: any[];
  height?: number;
  scheme?: 'paired' | 'red_yellow_green';
}

const ChartPie: React.FC<Props> = ({
  data,
  height = 250,
  scheme = 'paired',
}) => {
  const chartTheme = useChartTheme();

  return (
    <div style={{ height }}>
      <ResponsivePie
        data={data}
        colors={{ scheme }}
        margin={{ top: 0, right: 0, bottom: 70, left: 0 }}
        innerRadius={0.3}
        padAngle={1}
        cornerRadius={3}
        enableArcLinkLabels={false}
        arcLabelsTextColor="#fff"
        theme={chartTheme}
        legends={[
          {
            anchor: 'right',
            direction: 'column',
            justify: false,
            itemsSpacing: 0,
            itemWidth: 100,
            itemHeight: 20,
            itemTextColor: '#999',
            itemDirection: 'right-to-left',
            itemOpacity: 1,
            symbolSize: 10,
            symbolShape: 'circle',
          },
        ]}
      />
    </div>
  );
};

export default ChartPie;
